var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application-root",attrs:{"id":"app"}},[(this.$route.name != 'dashboard')?_c('navbar'):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }